import store from '@/store'
import { parseQuery } from '@/utils/location'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import { getToken } from '@/utils/auth'
import api from '@/api/im-chat'
import { formartMsgs } from '@/utils/msg-types'
import { EventBus } from '@/utils/eventBus'

let clickNum = 0
let ctrl = null
let fetchAiMessageId = null
let typeInterval = null
const messages = []
let currentChunk = null
let reconnectAttempts = 0
let sendContent = ''
let timer = null
const isInit = false
const htmlType = ''
let sendClick = 0
let sendTimer = null
let txt = '抱歉，您的问题小九暂时无法解决，请联系人工客服协助。'

const htmlEntities = ['{html}', '{txtHtml}']

// 取路径
export function parseHashQuerys() {
  const query = parseQuery(location.hash.replace(/#.+\?/, '?'))
  return query || {}
}
export function formatReceive(dispatch) {
  dispatch('formatReceiveMsg', {
    type: 600998,
    content: currentChunk.displayContent,
    messageId: fetchAiMessageId,
    component: currentChunk.component
  })
}
// 更新打字机效果
export function updateTypewriterEffect({ commit, dispatch }) {
  if (typeInterval) return
  if (!currentChunk) {
    return
  }
  typeInterval = setInterval(() => {
    if (currentChunk.index < currentChunk.content.length) {
      currentChunk.displayContent += currentChunk.content.charAt(currentChunk.index)
      // 流式会话更新消息
      formatReceive(dispatch)
      currentChunk.index++
    } else {
      if (currentChunk.status === 'complete') {
        finalizeMessage({ commit, dispatch })
      }
    }
  }, 10) // 调整打字速度
}

// 最终完成处理
export function finalizeMessage({ commit, dispatch }) {
  EventBus.$off('messageSent')
  currentChunk = null
  clearInterval(typeInterval)
  typeInterval = null
  commit('updateStreamingFlag', false)
  clickNum = 0
  timer && clearTimeout(timer)
  console.log('断开关闭连接')
}

// 创建新消息
export function createNewMessage() {
  currentChunk = {
    id: Date.now(),
    role: 'assistant',
    content: '',
    displayContent: '',
    copyContent: '',
    status: 'loading',
    index: 0,
    completeContent: '',
    component: ''
  }
  messages.push(currentChunk)
}

// 处理流式数据块
export function handleStreamChunk(chunk, { commit, dispatch }) {
  if (!currentChunk) {
    createNewMessage()
  }
  currentChunk.content += formatContent(chunk.answer || '')
  currentChunk.copyContent += chunk.answer || ''
  // 判断如果是html标签，则直接替换
  if (htmlEntities.some(entity => currentChunk.copyContent.includes(entity))) {
    currentChunk.displayContent = currentChunk.content
    formatReceive(dispatch)
  } else {
    sendTimer = setTimeout(() => {
      updateTypewriterEffect({ commit, dispatch })
      sendTimer && clearTimeout(sendTimer)
    }, 50)
  }
}

// 处理流式数据块-2
export function handleStreamChunkV2(chunk, { commit, dispatch }) {
  if (!currentChunk) {
    createNewMessage()
  }
  currentChunk.component = chunk.component
  currentChunk.content += formatContent(chunk.answer || '')
  currentChunk.displayContent = currentChunk.content
  if (currentChunk && currentChunk.displayContent) {
    formatReceive(dispatch)
  }
}

// 处理断开连接
export function handleDisconnection({ commit, dispatch }, content) {
  if (reconnectAttempts < 3) {
    setTimeout(() => {
      reconnectAttempts++
      dispatch('sendAiMessage', content)
    }, 2000 * reconnectAttempts)
  }
}

// 格式化内容（可选）
export function formatContent(content) {
  // 可以添加Markdown解析或链接检测
  return content.replace(/{html}|{txt}|{txtHtml}/g, '')
}

// 添加一个 action 来终止事件流
export function abortFetchEventSource({ commit, state, dispatch }, txt) {
  const taskId = store.state.chat.taskId
  const { sessionId, pageId, sc } = store.state.chat.chatInfo
  console.log('taskId=' + taskId)
  console.log('ctrl=' + ctrl)
  console.log('sessionId=' + sessionId)
  if (ctrl) {
    if (taskId && currentChunk && currentChunk.displayContent) {
      sessionId &&
        api
          .apiStopChatbot({
            user: sessionId,
            taskId: taskId
          })
          .then(() => {
            commit('updateTaskId', '')
          })
    } else {
      dispatch('formatReceiveMsg', {
        type: 600998,
        content: `<span><i className="el-icon-loading"></i>${txt || '停止回复'}</span>`,
        messageId: fetchAiMessageId,
        component: ''
      })
    }
    finalizeMessage({ commit, dispatch })
    ctrl.abort()
    console.log('事件流已终止')
  }
}

// 预发消息
export function preFetchEventSource(data, { commit, dispatch, state }, callback) {
  try {
    api
      .apiPreSendChatbot(data)
      .then(async res => {
        if (res.code === 1) {
          fetchAiMessageId = Date.now()
          EventBus.$on('messageSent', message => {
            console.log(message, 'sendOk')
            EventBus.$off('messageSent')

            if (message === 'sendOk') {
              sendClick++
              if (sendClick < 2) {
                timer = setTimeout(() => {
                  try {
                    store
                      .dispatch(
                        'chat/pushMsgs',
                        formartMsgs([
                          {
                            messageId: fetchAiMessageId,
                            content: '<span><i class="el-icon-loading" style="margin-right:6px;"></i>思考中.....</span>'
                          }
                        ])
                      )
                      .then(res => {
                        callback && callback()
                      })
                  } catch (e) {
                    // dispatch('abortFetchEventSource', txt)
                  }
                }, 200)
              }
            }
          })
        }
      })
      .catch(e => {
        // dispatch('abortFetchEventSource', txt)
      })
  } catch (e) {
    // dispatch('abortFetchEventSource', txt)
  }
}

export async function sendAiMessage({ commit, dispatch, state }, content) {
  console.log('连续点击')
  if (state.streamingFlag) return
  sendClick = 0
  clickNum++
  if (clickNum > 1) return
  sendContent = content
  const query = parseHashQuerys()
  const Url = `${process.env.VUE_APP_baseURL}message/sendChatbot`
  const { sessionId, pageId, sc } = store.state.chat.chatInfo
  const data = {
    text: content,
    dialogId: sessionId,
    pageId,
    sc
  }
  commit('updateStreamingFlag', true)
  preFetchEventSource(data, { commit, dispatch }, () => {
    if (typeof EventSource !== 'undefined') {
      if (ctrl) {
        ctrl.abort()
      }
      ctrl = new AbortController()
      try {
        fetchEventSource(Url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            kftoken: query.customCode || getToken()
          },
          body: JSON.stringify({
            ...data,
            conversationId: state.conversationId
          }),
          openWhenHidden: true,
          signal: ctrl.signal, // 使用 AbortController 的 signal
          onopen: response => {
            console.log('连接已打开', response)
          },
          onmessage: event => {
            const res = JSON.parse(event.data)
            commit('updateTaskId', res.task_id)
            commit('updateConversationId', res.conversation_id)
            commit('updateAiEvent', res.event)
            commit('updateThinkLoading', true)
            if (res.event === 'workflow_started') {
              // 新消息开始
              currentChunk = null
            } else if (res.event === 'message') {
              if (res && res.answer && res.answer.length > 0) {
                handleStreamChunkV2(res, { commit, dispatch })
              }
            } else if (res.event === 'message_end') {
              currentChunk.status = 'complete'
            } else if (res.event === 'error') {
              dispatch('abortFetchEventSource', txt)
            }
          },
          onerror: error => {
            console.log(error, 'error')
            if (ctrl.signal.aborted) {
              console.log('onerror: 信号已终止，忽略错误')
              return
            }
            dispatch('abortFetchEventSource', txt)
            throw error
          },
          onclose: () => {
            if (ctrl.signal.aborted) {
              console.log('onerror: 信号已终止，忽略错误')
              return
            }
            if (currentChunk.status === 'complete') {
              EventBus.$off('messageSent')
              clearInterval(typeInterval)
              typeInterval = null
              commit('updateStreamingFlag', false)
              clickNum = 0
              timer && clearTimeout(timer)
            }
            console.log('连接已关闭')
          }
        })
      } catch (e) {
        // dispatch('abortFetchEventSource', txt)
        console.log('catch: 终止事件流')
      }
    }
  })
}
